import { styled, Toolbar } from "@mui/material";
// This component is used in the Navbar, the Footer, and the Topbar components,
// ensuring parity in the styling of the toolbar across the application.
export const StyledToolbar = styled(Toolbar, {
    shouldForwardProp: (prop) => prop !== "backgroundColor",
})(({ backgroundColor }) => ({
    backgroundColor: backgroundColor,
}));
